const parseLegacyModelOptions = (rawValue) => {
  const values = String(rawValue || '')
    .split(/\r?\n|,/)
    .map((value) => value.trim())
    .filter(Boolean);

  return Array.from(new Set(values)).map((value) => ({
    label: value,
    value,
    enabled: true,
  }));
};

export const extractEnabledAiModelOptions = (settingsPayload = {}, capability = 'regeneration') => {
  const configuredModels = Array.isArray(settingsPayload?.REGEN_MODEL_CATALOG)
    && settingsPayload.REGEN_MODEL_CATALOG.length > 0
    ? settingsPayload.REGEN_MODEL_CATALOG
    : parseLegacyModelOptions(settingsPayload?.REGEN_MODEL_OPTIONS);

  const seen = new Set();
  return configuredModels
    .filter((item) => item && item.enabled !== false && item?.capabilities?.[capability] !== false)
    .reduce((options, item) => {
      const value = String(item.value || '').trim();
      const key = value.toLowerCase();
      if (!value || seen.has(key)) return options;
      seen.add(key);
      options.push({
        label: String(item.label || value).trim() || value,
        value,
      });
      return options;
    }, []);
};
